module.exports = __webpack_public_path__ + "deleteIcon.png?02d321edc6e03aea1675001899d8f479";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vis/dist/img/network/deleteIcon.png
// module id = 569
// module chunks = 0